import { nameEncodeMap } from "../../../../../../utils/mappings";
import formatter from "../../../../../../utils/formatter";

export const dataFormatter = (data,isMoneyMarket) => {
    let newData = {};
    let totalPercent = 0;
    if(isMoneyMarket === true){
    data.map(each=>{
        let name = each.investmentOption.replace(/[ .-]/g, (l) => {
            if (l === '.') return nameEncodeMap().dot;
            if (l === ' ') return nameEncodeMap().single_space;
            return nameEncodeMap().hyphen; 
          });
        return newData[name]= {Percentage: name === "Conservative_Growth" ? 100 : ''};
    })
  }else{
    data.map(each=>{
      let name = each.investmentOption.replace(/[ .-]/g, (l) => {
          if (l === '.') return nameEncodeMap().dot;
          if (l === ' ') return nameEncodeMap().single_space;
          return nameEncodeMap().hyphen; 
        });
      totalPercent = parseInt(totalPercent) + parseInt(each.percentShare ? formatter({
        value: each.percentShare,
        fieldSuffix: "Percentage",
      }).split('%')[0] : 0);
      return newData[name]= {Percentage: each.percentShare ? formatter({
        value: each.percentShare,
        fieldSuffix: "Percentage",
      }).split('%')[0] : ''};
  })
  }
    return {newData, "totalPercent": totalPercent};
    }
    
  